import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { ResidenceResponse } from '@core/models/residence-response.model';

@Injectable({
	providedIn: 'root'
})
export class ResidenceService {

	constructor(
		private rest: RestService,
	) {
	}

	async getResidenceResponse(offset, limit): Promise<ResidenceResponse> {
		const resResp = await this.rest.get<ResidenceResponse>('Residences/Me?Limit=' + limit + '&Offset=' + offset, [], new ResidenceResponse(), false);
		return resResp.toPromise();
	}
}
